module.exports = __webpack_public_path__ + "assets/eb690bc32326bb26346137a33561a7b7.mp3";